import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-email-modal',
  templateUrl: './edit-email-modal.component.html',
  styleUrls: ['./edit-email-modal.component.scss']
})
export class EditEmailModalComponent implements OnInit {
  @Input() public email: string;
  @Input() public title: string;
  @Input() public buttonText: String = 'Ja, löschen';
  @Output() sendData: EventEmitter<any> = new EventEmitter();

  constructor(public modal: NgbActiveModal, public translate: TranslateService, private snackBar: MatSnackBar) {}

  ngOnInit() {}

  onConfirm(): void {
    if (this.email) {
      this.modal.close({
        success: true,
        data: this.email
      });
    } else {
      this.snackBar.open('Email is required.', 'Close', { duration: 2000 });
    }
  }
}
